export enum TimingEventType {
	COLLECTION = 'COLLECTION',
	DATE = 'DATE',
	DEBUG = 'DEBUG',
	HEIGHT = 'HEIGHT',
	IMAGE = 'IMAGE',
	LOCATION = 'LOCATION',
	NAVIGATION = 'NAVIGATION',
	NESTED_LIST = 'NESTED_LIST',
	NUMBER = 'NUMBER',
	IKE_PHOTO = 'IKE_PHOTO',
	PHOTOMEASURE = 'PHOTOMEASURE',
	TOPOLOGICAL_EDITOR = 'TOPOLOGICAL_EDITOR',
	SELECT_LIST = 'SELECT_LIST',
	SUBFORM = 'SUBFORM',
	TEXT = 'TEXT',
	UPLOAD = 'UPLOAD',
	VECTOR = 'VECTOR',
	YES_NO = 'YES_NO',
	HOA = 'HOA',
}

export enum TimingEventAction {
	BACK = 'BACK',
	CANCEL = 'CANCEL',
	CAPTURE = 'CAPTURE',
	DELETE = 'DELETE',
	EDIT = 'EDIT',
	ENTER = 'ENTER',
	EXIT = 'EXIT',
	MENU = 'MENU',
	REVIEW = 'REVIEW',
	SELECT = 'SELECT',
	UPLOAD = 'UPLOAD',
	EXPORT = 'EXPORT',
}
